var _g, _g2, _path, _path2, _rect, _rect2, _rect3, _g3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _g4, _g5, _g6, _g7, _g8, _path3, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _g9, _rect21, _rect22, _rect23, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoWidgetsDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 649,
    height: 409,
    viewBox: "0 0 649 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15395_9195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.4351,
    y: 65.4652,
    width: 518.961,
    height: 318.344,
    rx: 12.013,
    fill: "#3E4274"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_15395_9195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.4053,
    y: 84.6141,
    width: 96.4797,
    height: 280.162,
    rx: 6.00649,
    fill: "#2B2753"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.042 112.273C104.119 112.353 104.179 112.448 104.219 112.551C104.262 112.656 104.285 112.768 104.286 112.881H96.2086L93.9697 112.856C93.9697 112.856 92.7328 112.888 91.7892 112.888H87.5747H83.8639C83.8619 112.775 83.8836 112.663 83.9275 112.558C83.9702 112.454 84.0339 112.359 84.1148 112.28L87.3468 109.054L89.4248 106.982L93.4537 102.96C93.5334 102.879 93.6283 102.815 93.7329 102.771C93.8384 102.728 93.9512 102.706 94.0652 102.706C94.1785 102.706 94.2907 102.728 94.3956 102.771C94.5008 102.815 94.5963 102.879 94.6766 102.96L98.7408 107.005L100.849 109.098L104.042 112.273Z",
    fill: "#5D619C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.559 113.834L94.6789 119.661C94.5105 119.83 94.2971 119.912 94.0681 119.912C93.8391 119.912 93.6195 119.822 93.4573 119.661L87.5703 113.834H83.8633C83.8622 113.946 83.8838 114.058 83.9269 114.162C83.9695 114.266 84.0332 114.36 84.114 114.438L93.4591 123.688C93.5381 123.769 93.633 123.834 93.738 123.877C93.8431 123.921 93.9559 123.944 94.0699 123.944C94.1839 123.944 94.2967 123.921 94.4017 123.877C94.5067 123.834 94.6016 123.769 94.6806 123.688L104.035 114.438C104.115 114.359 104.18 114.265 104.223 114.162C104.266 114.058 104.287 113.946 104.285 113.834H100.559Z",
    fill: "#5D619C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.5381,
    y: 135.377,
    width: 74.2151,
    height: 9.27689,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83.5381,
    y: 172.485,
    width: 74.2151,
    height: 9.27689,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83.5381,
    y: 153.931,
    width: 74.2151,
    height: 9.27689,
    rx: 1.45607,
    fill: "#5D619C"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_15395_9195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.835,
    y: 252.034,
    width: 381.547,
    height: 106.432,
    rx: 6.00649,
    fill: "#2B2753"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 197.914,
    y: 280.145,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 197.918,
    y: 320.31,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 197.917,
    y: 300.228,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 320.413,
    y: 280.146,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 320.41,
    y: 320.31,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 320.413,
    y: 300.228,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 442.908,
    y: 280.147,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 442.912,
    y: 320.31,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 442.908,
    y: 300.228,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_15395_9195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.565,
    y: 84.686,
    width: 117.191,
    height: 50.4545,
    rx: 6.00649,
    fill: "#2B2753"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_15395_9195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.976,
    y: 84.686,
    width: 117.191,
    height: 50.4545,
    rx: 6.00649,
    fill: "#2B2753"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_15395_9195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.565,
    y: 144.751,
    width: 189.805,
    height: 96.1039,
    rx: 6.00649,
    fill: "#2B2753"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_15395_9195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 442.387,
    y: 84.686,
    width: 117.191,
    height: 50.4545,
    rx: 6.00649,
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_15395_9195)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_15395_9195)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 269.809,
    width: 79.2857,
    height: 79.2857,
    rx: 4.50577,
    fill: "#5F8AF6"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8317 292.807C55.8317 291.964 55.1481 291.28 54.3049 291.28C53.4617 291.28 52.7782 291.964 52.7782 292.807L52.7782 307.566H38.0194C37.1762 307.566 36.4927 308.249 36.4927 309.092C36.4927 309.936 37.1762 310.619 38.0194 310.619H52.7782V325.378C52.7782 326.221 53.4617 326.905 54.3049 326.905C55.1481 326.905 55.8317 326.221 55.8317 325.378V310.619H70.5904C71.4336 310.619 72.1172 309.936 72.1172 309.092C72.1172 308.249 71.4336 307.566 70.5904 307.566H55.8317L55.8317 292.807Z",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 188.376,
    y: 105.108,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 320.52,
    y: 105.108,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#5D619C"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 452.662,
    y: 105.108,
    width: 96.3909,
    height: 10.0407,
    rx: 1.45607,
    fill: "#DFE8FE"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 194.383,
    y: 228.842,
    width: 26.4286,
    height: 26.4286,
    rx: 1.45607,
    transform: "rotate(-90 194.383 228.842)",
    fill: "#5D619C"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 260.455,
    y: 228.842,
    width: 15.6169,
    height: 26.4286,
    rx: 1.45607,
    transform: "rotate(-90 260.455 228.842)",
    fill: "#5D619C"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 226.818,
    y: 228.842,
    width: 66.0714,
    height: 27.6299,
    rx: 1.45607,
    transform: "rotate(-90 226.818 228.842)",
    fill: "#5D619C"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 326.526,
    y: 228.842,
    width: 32.4351,
    height: 26.4286,
    rx: 1.45607,
    transform: "rotate(-90 326.526 228.842)",
    fill: "#5D619C"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 292.89,
    y: 228.842,
    width: 49.2532,
    height: 27.6299,
    rx: 1.45607,
    transform: "rotate(-90 292.89 228.842)",
    fill: "#5D619C"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_15395_9195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.123 67.7875C376.381 64.5544 378.4 61.3315 381.633 60.5891L579.503 15.1537C582.736 14.4113 585.959 16.4304 586.701 19.6636L623.533 180.067C624.276 183.3 622.257 186.523 619.024 187.265L421.154 232.701C417.92 233.443 414.698 231.424 413.955 228.191L377.123 67.7875Z",
    fill: "#2B2753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.294 67.5187C378.147 66.8815 378.135 66.2478 378.237 65.6448L377.053 65.4446C377.317 63.8774 378.199 62.4699 379.494 61.5479L380.191 62.5265C380.689 62.1717 381.264 61.9063 381.902 61.76L384.812 61.0918L384.543 59.921L390.362 58.5846L390.631 59.7555L396.451 58.4191L396.182 57.2483L402.002 55.912L402.271 57.0828L408.09 55.7465L407.821 54.5756L413.641 53.2393L413.91 54.4101L419.73 53.0738L419.461 51.903L425.281 50.5666L425.549 51.7374L431.369 50.4011L431.1 49.2303L436.92 47.8939L437.189 49.0648L443.009 47.7284L442.74 46.5576L448.559 45.2213L448.828 46.3921L454.648 45.0558L454.379 43.8849L460.199 42.5486L460.468 43.7194L466.287 42.3831L466.019 41.2123L471.838 39.8759L472.107 41.0467L477.927 39.7104L477.658 38.5396L483.478 37.2032L483.746 38.3741L489.566 37.0377L489.297 35.8669L495.117 34.5306L495.386 35.7014L501.206 34.3651L500.937 33.1942L506.756 31.8579L507.025 33.0287L512.845 31.6924L512.576 30.5216L518.396 29.1852L518.665 30.356L524.484 29.0197L524.216 27.8489L530.035 26.5125L530.304 27.6834L536.124 26.347L535.855 25.1762L541.675 23.8399L541.944 25.0107L547.763 23.6744L547.494 22.5035L553.314 21.1672L553.583 22.338L559.403 21.0017L559.134 19.8309L564.954 18.4945L565.222 19.6653L571.042 18.329L570.773 17.1582L576.593 15.8218L576.862 16.9927L579.772 16.3245C580.409 16.1782 581.043 16.166 581.646 16.2678L581.846 15.0833C583.413 15.3482 584.82 16.23 585.742 17.5247L584.764 18.2215C585.119 18.7197 585.384 19.2952 585.53 19.9324L586.188 22.7968L587.359 22.5279L588.674 28.2566L587.504 28.5255L588.819 34.2542L589.99 33.9853L591.305 39.714L590.134 39.9829L591.45 45.7115L592.621 45.4427L593.936 51.1714L592.765 51.4402L594.081 57.1689L595.252 56.9001L596.567 62.6288L595.396 62.8976L596.712 68.6263L597.882 68.3575L599.198 74.0862L598.027 74.355L599.342 80.0837L600.513 79.8149L601.829 85.5436L600.658 85.8124L601.973 91.5411L603.144 91.2723L604.46 97.0009L603.289 97.2698L604.604 102.998L605.775 102.73L607.09 108.458L605.92 108.727L607.235 114.456L608.406 114.187L609.721 119.916L608.551 120.185L609.866 125.913L611.037 125.644L612.352 131.373L611.181 131.642L612.497 137.371L613.668 137.102L614.983 142.831L613.812 143.099L615.128 148.828L616.299 148.559L617.614 154.288L616.443 154.557L617.759 160.285L618.929 160.017L620.245 165.745L619.074 166.014L620.389 171.743L621.56 171.474L622.876 177.203L621.705 177.472L622.363 180.336C622.509 180.973 622.521 181.607 622.419 182.21L623.604 182.41C623.339 183.977 622.457 185.385 621.162 186.307L620.466 185.328C619.967 185.683 619.392 185.948 618.755 186.095L615.845 186.763L616.114 187.934L610.294 189.27L610.025 188.099L604.205 189.435L604.474 190.606L598.655 191.943L598.386 190.772L592.566 192.108L592.835 193.279L587.015 194.615L586.746 193.444L580.927 194.781L581.195 195.952L575.376 197.288L575.107 196.117L569.287 197.453L569.556 198.624L563.736 199.961L563.468 198.79L557.648 200.126L557.917 201.297L552.097 202.633L551.828 201.462L546.008 202.799L546.277 203.97L540.458 205.306L540.189 204.135L534.369 205.471L534.638 206.642L528.818 207.979L528.549 206.808L522.73 208.144L522.998 209.315L517.179 210.651L516.91 209.48L511.09 210.817L511.359 211.988L505.539 213.324L505.27 212.153L499.451 213.49L499.72 214.66L493.9 215.997L493.631 214.826L487.811 216.162L488.08 217.333L482.261 218.669L481.992 217.499L476.172 218.835L476.441 220.006L470.621 221.342L470.352 220.171L464.533 221.508L464.801 222.678L458.982 224.015L458.713 222.844L452.893 224.18L453.162 225.351L447.342 226.687L447.073 225.517L441.254 226.853L441.523 228.024L435.703 229.36L435.434 228.189L429.614 229.526L429.883 230.696L424.063 232.033L423.795 230.862L420.885 231.53C420.248 231.676 419.614 231.689 419.011 231.587L418.811 232.771C417.243 232.506 415.836 231.625 414.914 230.33L415.893 229.633C415.538 229.135 415.272 228.559 415.126 227.922L414.468 225.058L413.297 225.327L411.982 219.598L413.153 219.329L411.837 213.6L410.667 213.869L409.351 208.141L410.522 207.872L409.207 202.143L408.036 202.412L406.72 196.683L407.891 196.414L406.576 190.686L405.405 190.954L404.089 185.226L405.26 184.957L403.945 179.228L402.774 179.497L401.459 173.768L402.629 173.5L401.314 167.771L400.143 168.04L398.828 162.311L399.998 162.042L398.683 156.313L397.512 156.582L396.197 150.854L397.368 150.585L396.052 144.856L394.881 145.125L393.566 139.396L394.737 139.127L393.421 133.399L392.25 133.668L390.935 127.939L392.106 127.67L390.79 121.941L389.62 122.21L388.304 116.481L389.475 116.213L388.16 110.484L386.989 110.753L385.673 105.024L386.844 104.755L385.529 99.0265L384.358 99.2954L383.042 93.5667L384.213 93.2978L382.898 87.5691L381.727 87.838L380.412 82.1093L381.582 81.8404L380.267 76.1117L379.096 76.3806L377.781 70.6519L378.951 70.3831L378.294 67.5187Z",
    stroke: "#5CC9FA",
    strokeWidth: 2.4026,
    strokeDasharray: "6.01 6.01"
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 532.062,
    y: 87.6752,
    width: 45.6493,
    height: 9.61039,
    rx: 1.45607,
    transform: "rotate(-12.9322 532.062 87.6752)",
    fill: "#5D619C"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 540.935,
    y: 126.312,
    width: 45.6493,
    height: 10.8117,
    rx: 1.45607,
    transform: "rotate(-12.9322 540.935 126.312)",
    fill: "#5D619C"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 536.633,
    y: 107.579,
    width: 45.6493,
    height: 9.61039,
    rx: 1.45607,
    transform: "rotate(-12.9322 536.633 107.579)",
    fill: "#5D619C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M476.425 175.378C468.711 176.738 460.783 176.306 453.241 174.114C445.699 171.923 438.74 168.03 432.891 162.729C427.042 157.428 422.455 150.859 419.479 143.518C416.502 136.177 415.214 128.257 415.71 120.356C416.207 112.455 418.475 104.781 422.345 97.9141C426.214 91.0471 431.583 85.167 438.044 80.7186C444.506 76.2703 451.892 73.3701 459.643 72.2376C467.394 71.105 475.307 71.7697 482.784 74.1813L478.911 86.6178C473.303 84.8091 467.368 84.3106 461.555 85.16C455.742 86.0094 450.203 88.1845 445.356 91.5208C440.51 94.8571 436.484 99.2671 433.582 104.417C430.68 109.568 428.978 115.323 428.606 121.249C428.233 127.174 429.2 133.115 431.432 138.62C433.665 144.126 437.104 149.053 441.491 153.029C445.878 157.004 451.097 159.924 456.754 161.568C462.41 163.211 468.356 163.535 474.142 162.515L476.425 175.378Z",
    fill: "#DFE8FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M513.428 147.707C509.819 154.909 504.6 161.157 498.182 165.958C491.763 170.759 484.321 173.983 476.442 175.375L474.155 162.513C480.064 161.469 485.645 159.051 490.459 155.45C495.273 151.849 499.188 147.163 501.894 141.762L513.428 147.707Z",
    fill: "#3E6CE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M490.695 77.4809C496.747 80.6171 502.134 84.924 506.549 90.1557C510.964 95.3873 514.321 101.441 516.427 107.972C518.533 114.502 519.348 121.382 518.824 128.217C518.301 135.052 516.45 141.71 513.377 147.809L501.856 141.839C504.161 137.264 505.549 132.271 505.941 127.145C506.334 122.018 505.723 116.859 504.143 111.961C502.564 107.063 500.046 102.522 496.735 98.5986C493.424 94.6748 489.383 91.4447 484.844 89.0925L490.695 77.4809Z",
    fill: "#5F8AF6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M437.297 81.2427C445.008 75.7299 454.08 72.4709 463.523 71.8213C472.966 71.1716 482.417 73.1564 490.845 77.559L484.957 89.1511C478.636 85.8491 471.547 84.3606 464.465 84.8478C457.383 85.335 450.579 87.7793 444.796 91.9139L437.297 81.2427Z",
    fill: "#A9C2FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15395_9195",
    x: 42.4351,
    y: 50.4652,
    width: 558.961,
    height: 358.344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15395_9195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15395_9195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_15395_9195",
    x: 57.4053,
    y: 69.6141,
    width: 136.479,
    height: 320.162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15395_9195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15395_9195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_15395_9195",
    x: 162.835,
    y: 237.034,
    width: 421.547,
    height: 146.432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15395_9195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15395_9195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_15395_9195",
    x: 162.565,
    y: 69.686,
    width: 157.191,
    height: 90.4545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15395_9195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15395_9195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_15395_9195",
    x: 294.976,
    y: 69.686,
    width: 157.191,
    height: 90.4545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15395_9195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15395_9195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_15395_9195",
    x: 162.565,
    y: 129.751,
    width: 229.805,
    height: 136.104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15395_9195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15395_9195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_15395_9195",
    x: 427.971,
    y: 73.8743,
    width: 143.62,
    height: 76.8831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.2013,
    dy: 2.4026
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.60714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15395_9195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15395_9195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_15395_9195",
    x: 0,
    y: 254.809,
    width: 119.286,
    height: 119.286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15395_9195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15395_9195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_15395_9195",
    x: 4.18616,
    y: 261.699,
    width: 99.111,
    height: 99.1111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.901154,
    dy: 1.80231
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95634
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.562222 0 0 0 0 0.580156 0 0 0 0 0.766667 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15395_9195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15395_9195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_15395_9195",
    x: 361.969,
    y: 0,
    width: 286.718,
    height: 257.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15395_9195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15395_9195",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWidgetsDark);
export default __webpack_public_path__ + "static/media/noWidgetsDark.95c685d652ae81cd44f170279af10dc2.svg";
export { ForwardRef as ReactComponent };